import { getItemFromCollection } from "directus/src/operations";
import { assetUrl } from "utils";
import {
  COLLECTION,
  FILES_FIELD,
  FILES_JUNCTION_KEY,
  SKILLS_FIELD,
  SKILLS_JUNCTION_KEY,
} from "../../constants";

export async function fetchDeliverableData({ deliverableId }) {
  try {
    return await getItemFromCollection(COLLECTION, deliverableId, {
      fields: [
        "id",
        "name",
        "type",
        "url",
        "project",
        `${SKILLS_FIELD}.id`,
        `${SKILLS_FIELD}.${SKILLS_JUNCTION_KEY}`,
        `${FILES_FIELD}.id`,
        `${FILES_FIELD}.${FILES_JUNCTION_KEY}.id`,
        `${FILES_FIELD}.${FILES_JUNCTION_KEY}.type`,
        `${FILES_FIELD}.${FILES_JUNCTION_KEY}.filename_download`,
      ],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * Splits a deliverable response into plain form values and
 * related-id -> junction-row-id maps used to build M2M change sets on update.
 */
export function toFormValues(response) {
  const skillJunctions = new Map();
  (response?.[SKILLS_FIELD] ?? []).forEach((row) => {
    const skillId = row?.[SKILLS_JUNCTION_KEY]?.id ?? row?.[SKILLS_JUNCTION_KEY];
    if (skillId != null) skillJunctions.set(skillId, row.id);
  });

  const fileJunctions = new Map();
  const files = [];
  (response?.[FILES_FIELD] ?? []).forEach((row) => {
    const file = row?.[FILES_JUNCTION_KEY];
    if (!file?.id) {
      // Junction row with no file (saved under a wrong key earlier): never
      // selected, so the next files change deletes it
      if (row?.id != null) fileJunctions.set(`orphan:${row.id}`, row.id);
      return;
    }
    fileJunctions.set(file.id, row.id);
    const type = file.type || "";
    files.push({
      id: file.id,
      name: file.filename_download || file.id,
      type,
      url: assetUrl(file.id),
      isImage: type.startsWith("image/"),
      isVideo: type.startsWith("video/"),
    });
  });

  return {
    values: {
      ...response,
      [SKILLS_FIELD]: [...skillJunctions.keys()],
      [FILES_FIELD]: files,
    },
    skillJunctions,
    fileJunctions,
  };
}
